export default __webpack_public_path__ + "static/media/class_notes.1b94fec7.svg";